import { useEffect, useState } from "react"
import useCookie from "react-use-cookie";
import { HUGE_LIKE_BUTTON_TEXT_OPTIONS } from "../../constants"

const useHugeLikeButtonConfiguration = (metaURL) => {
  const [hugeLikeText, setHugeLikeText] = useState("Huuuuuge like!")
  const [hugeLikeCounter, setHugeLikeCounter] = useState(0)
  const [userToken, setUserToken] = useCookie(metaURL)

  useEffect(() => {
    if (userToken) {
      setHugeLikeText("Thank You! ;)")
    }
  }, [])

  const hugeLikeTextHandler = () => {
    if (!userToken) {
      if (hugeLikeCounter < HUGE_LIKE_BUTTON_TEXT_OPTIONS.length) {
        setHugeLikeText(HUGE_LIKE_BUTTON_TEXT_OPTIONS[hugeLikeCounter])
        setHugeLikeCounter(prev => prev + 1)
      } else {
        setUserToken(true)
      }
    }
  }

  return {
    hugeLikeText,
    hugeLikeTextHandler
  }
}

export default useHugeLikeButtonConfiguration
